import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Capacitor } from '@capacitor/core';
import { PLAY_STORE_URL } from '../../config/appStoreLinks';
import { isAndroidUserAgent } from '../../utils/mobileWebPromo';

/** 手機版官網（Android）：Header 低調 Google Play 入口，不推 PWA */
const WebPlayStoreHeaderLink: React.FC = () => {
  if (Capacitor.isNativePlatform() || !isAndroidUserAgent()) {
    return null;
  }

  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="md:hidden inline-flex items-center gap-1 rounded-md border border-blue-200 bg-blue-50 px-2.5 py-1.5 text-xs font-semibold text-blue-700 hover:bg-blue-100 touch-manipulation min-h-[44px]"
    >
      Google Play
      <ExternalLink className="h-3.5 w-3.5 shrink-0 opacity-80" aria-hidden />
    </a>
  );
};

export default WebPlayStoreHeaderLink;
